import React from 'react';
import { Alert } from 'reactstrap';
import classNames from 'classnames';

import { Icon } from 'js/components';

import styles from './InlineAlert.module.scss';

/**
 * A note that sits in the page, as opposed to a toast: a light surface with
 * an icon, the message, and `actions` (link buttons) after it.
 */
export function InlineAlert({ icon, actions, className, children }) {
  return (
    <Alert color="info" className={classNames(styles.alert, className)}>
      {icon && <Icon icon={icon} className={styles.icon} />}
      <span className={styles.message}>{children}</span>
      {actions && <span className={styles.actions}>{actions}</span>}
    </Alert>
  );
}

export default InlineAlert;
